import _extends from "@babel/runtime/helpers/extends";
import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _class, _descriptor, _descriptor2;
/*
 *                     NOTICE
 *            COPYRIGHT 2018 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { observable, action, makeObservable } from "mobx";
import * as React from "react";
import { AbWithTooltip } from "abreact/popup/AbWithTooltip";
export let DataGridCell = (_dec = observable.ref, _class = class DataGridCell extends React.Component {
  get divRef() {
    return this._divRef;
  }
  constructor(props) {
    super(props);
    _defineProperty(this, "cachedStyles", {});
    _initializerDefineProperty(this, "_divRef", _descriptor, this);
    _initializerDefineProperty(this, "divRefCB", _descriptor2, this);
    makeObservable(this);
    this._divRef = undefined;
  }
  render() {
    let cellProps = this.props.gridCellProps;
    let content = this.props.getCellContent(cellProps, this.props.getCellRef);
    // console.log(`DataGridCell.render(): (${cellProps.rowIndex}, ${cellProps.columnIndex})`);
    let classNames = this.props.classNames;
    let tooltip = cellProps.tooltip;

    // This is necessary because getCellContent sometimes modifies the
    // object that is passed into it.
    if (cellProps.classNames) {
      classNames += " " + cellProps.classNames;
    }
    let styles = cellProps.style;
    if (cellProps.styles || this.props.column.styles || this.props.cellMeasurerCache) {
      styles = {
        ...cellProps.style,
        width: this.props.columnWidth,
        ...this.props.column.styles,
        ...cellProps.styles
      };
    }
    if (shallowEquals(styles, this.cachedStyles)) {
      styles = this.cachedStyles;
    } else {
      this.cachedStyles = styles;
    }
    if (tooltip && !this.props.gridCellProps.useNativeTooltip) {
      return /*#__PURE__*/React.createElement(AbWithTooltip, {
        tooltip: tooltip
      }, /*#__PURE__*/React.createElement("div", _extends({
        className: classNames,
        style: styles,
        "data-cell-column-index": cellProps.columnIndex,
        "data-cell-row-index": cellProps.rowIndex,
        "data-test-id": `cell-col-${cellProps.columnIndex}-row-${cellProps.rowIndex}`,
        onMouseDown: this.props.onMouseDown,
        onMouseEnter: this.props.onMouseEnter,
        onDoubleClick: this.props.onDoubleClick
      }, cellProps.eventHandlers, {
        ref: this.divRefCB
      }), content));
    } else {
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classNames,
        style: styles,
        title: tooltip,
        "data-cell-column-index": cellProps.columnIndex,
        "data-cell-row-index": cellProps.rowIndex,
        "data-test-id": `cell-col-${cellProps.columnIndex}-row-${cellProps.rowIndex}`,
        onMouseDown: this.props.onMouseDown,
        onMouseEnter: this.props.onMouseEnter,
        onDoubleClick: this.props.onDoubleClick
      }, cellProps.eventHandlers, {
        ref: this.divRefCB
      }), content);
    }
  }
  shouldComponentUpdate(nextProps) {
    let props = this.props;
    if (props.forceUpdate) {
      return true;
    }
    if (props.dataFreshness !== nextProps.dataFreshness) {
      return true;
    }
    if (props.refreshCount !== nextProps.refreshCount) {
      return true;
    }
    if (!props.cellMeasurementFreshness.isFreshInBodyGrid(nextProps.gridCellProps.rowIndex, nextProps.gridCellProps.columnIndex)) {
      return true;
    }
    if (!shallowEquals(props.gridCellProps.style, nextProps.gridCellProps.style)) {
      return true;
    }
    if (props.classNames !== nextProps.classNames) {
      return true;
    }
    return false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_divRef", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "divRefCB", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return ref => {
      this._divRef = ref;
    };
  }
}), _class);
function shallowEquals(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== "object" || typeof b !== "object") {
    return false;
  }
  let akeys = Object.keys(a);
  let bkeys = Object.keys(b);
  if (akeys.length !== bkeys.length) {
    return false;
  }
  for (let i = 0; i < akeys.length; i++) {
    let akey = akeys[i];
    let bkey = bkeys[i];
    if (a[akey] !== b[akey] || a[bkey] !== b[bkey]) {
      return false;
    }
  }
  return true;
}
//# sourceMappingURL=DataGridCell.js.map
